module.exports = __webpack_public_path__ + "static/media/item-8.8b9ba5be.png";